export default __webpack_public_path__ + "static/media/session.382f8212.svg";